const items = [
    { image: "/mainImages/playbutton/lsr-aware.png", url: "https://webglbucketvideos.s3.me-south-1.amazonaws.com/LSR+Aware.mp4" },
    { image: "/mainImages/playbutton/lsr-pro.png", url: "https://webglbucketvideos.s3.me-south-1.amazonaws.com/LSR+Pro.mp4" },
    { image: "/mainImages/playbutton/driving-aware-all-roads.png", url : "https://webglbucketvideos.s3.me-south-1.amazonaws.com/Driving+Aware.mp4" },
    { image: "/mainImages/playbutton/driving-pro-black-top.png", url: "https://webglbucketvideos.s3.me-south-1.amazonaws.com/Black+Top+Driving+Pro.mp4" },
    { image: "/mainImages/playbutton/driving-pro-graded-road.png", url: "https://webglbucketvideos.s3.me-south-1.amazonaws.com/Graded+Road+Driving+Pro.mp4" },
    { image: "/mainImages/playbutton/process-safety.png", url: "https://webglbucketvideos.s3.me-south-1.amazonaws.com/VIRSAT+Process+Safety.mp4" }
];

const GameVids = () => {
  return (
    <div className="gameplay-section">
      <p className="module-title"> Sample Vidoes</p>
      <div className="play-gap">
        <div className="checkout-container-business">
          {items.map((item, index) => {
            const fileName = item.image.split("/").pop().split(".")[0];
            return (
              <div key={index} className="item">
                {item.url ? (
                  <a href={item.url} target="_blank" rel="noopener noreferrer" className="image-container">
                    <img src={item.image} alt={fileName} className="game-image"/>
                    <div className="play-button-overlay">
                      <img src="/mainImages/Process-Safety-PC.png" alt="Play Button" className="play-button"/>
                      <div className="description-box-play" id="color-change">Play Video</div>
                    </div>
                  </a>
                ) : (
                  <div className="image-container">
                    <img src={item.image} alt={fileName} className="game-image"/>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default GameVids;